module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-step-3-9016754801462b4a6e64f8ce820c1de9.svg";